import React from 'react';

function Rank(props) {
  return (
    <div>Rank</div>
  )
}

export default React.memo(Rank);